/* eslint-disable react/no-direct-mutation-state */
import React from 'react';
import { connect } from "react-redux";
import { Popup, ToolbarItem } from 'devextreme-react/popup';
import { injectIntl } from "react-intl";
import Form, { Item as FormItem, SimpleItem, RequiredRule, GroupItem, RangeRule } from 'devextreme-react/form';
import { withSnackbar } from 'notistack';
import * as companiesCrud from '../../../../crud/companies.crud';
import * as contractsCrud from '../../../../crud/contracts.crud';

import * as settingsCrud from "../../../../crud/settings.crud";
import ScrollView from 'devextreme-react/scroll-view';


export const RESPONSES = {
    SAVE: 'SAVE',
    CANCEL: 'CANCEL',
};
const GetValueForDataType = (dataType, value) => {
    switch (dataType) {
        case 'STRING':
            return String(value);
        case 'NUMBER':
            return Number(value);
        case 'BOOLEAN':
            return (value === "TRUE");
        default:
            return value;
    }
};

class SystemSettingsCreateModal extends React.Component {
    constructor(props) {
        super(props);
        this.validatorRef = React.createRef();
        this.validatorName = 'SystemSettingsCreateModalValidator';
        this.formRef = React.createRef();
        this.popupRef = React.createRef();
        this.fileUploaderRef = React.createRef();
        this.uploadButtonRef = React.createRef();
        this.formData = {}
        this.defaultFields = null;
        // this.companiesListDataSource = this.getCompaniesListDataSource();
        // this.settingDataPatternsDataSource = this.getSettingPatternsDataSource();

        this.state = {
            selectedPattern: null,
            selectedPatternValues: {},
            companiesList: [],
            settingPatternsList: [],
        }
    }
    componentDidMount() {
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.visible !== true && this.props.visible === true) {
            this.fetchCompaniesList();
            this.fetchSettingPatterns();

            if (this.formRef.current) {
                this.formRef.current.instance().clear();
            }
            if (this.popupRef.current) {
                this.popupRef.current.instance().option("toolbarItems[2].disabled", true);
            }
        }
        else if (prevProps.visible === true && this.props.visible === false) {
            //popup closed
            this.setState({ selectedPattern: null, selectedPatternValues: {} });
            const formInstance = this.formRef.current.instance();
            formInstance.option("formData", {});
        }

    }
    componentWillUnmount() {
        if (this.props.closeSnackbar) {
            this.props.closeSnackbar();
        }
    }
    onClose = (e) => {
        if (this.props.visible) {
            // e.cancel = true;
            if (this.props.closeSnackbar) {
                this.props.closeSnackbar();
            }
            this.props.onDialogResult();
        }
    }

    formFieldDataChanged = async (e) => {
        this.formData = e.component.option("formData");
        let popupInstance = this.popupRef.current.instance();
        if (popupInstance) {
            //ENABLE/DISABLE SAVE BUTTON BASED ON REQUIRED FIELDS
            if (!this.formData.companyid && !this.formData.settingspatternid) {
                //IF ANY FIELD CLEARED MAKE SURE save BUTTON IS DISABLED
                this.popupRef.current.instance().option("toolbarItems[2].disabled", true);
            }
            else {
                this.popupRef.current.instance().option("toolbarItems[2].disabled", false);
            }
        }
        if (this.props.closeSnackbar) {
            this.props.closeSnackbar();
        }
        if (e.dataField === 'companyid') {
            console.log("companyid changed to " + e.value, e);
            let contractDataSource = null;
            if (e.value) {
                let { data: contractOptions } = await contractsCrud.toSelectList(Number(e.value));
                contractDataSource = contractOptions;
                this.contractsListDataSource = contractOptions;
            }
            e.component.itemOption("contractid", "editorOptions", { dataSource: contractDataSource });
            e.component.updateData("contractid", null);
        }
        else if (e.dataField === 'settingspatternid') {
            try {
                if (e.value) {
                    let { data: pattern } = await settingsCrud.getSettingPattern(e.value);
                    let selectedPatternValues = {};
                    selectedPatternValues[pattern.Key] = GetValueForDataType(pattern.DataType, pattern.Value);
                    for (let associated of pattern.Associated || []) {
                        selectedPatternValues[associated.Key] = GetValueForDataType(associated.DataType, associated.Value);
                    }
                    e.component.updateData("contractid", null);
                    this.setState({ selectedPattern: pattern, selectedPatternValues });
                }
                else {
                    this.setState({ selectedPattern: null, selectedPatternValues: {} });
                }


            }
            catch (err) {
                this.setState({ selectedPattern: null, selectedPatternValues: {} });
                console.error(err);
                this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
            }
        }
        else if (e.dataField.startsWith("patternvalue_")) {
            let patternKey = e.dataField.replace("patternvalue_", "");
            let selectedPatternValues = { ...this.state.selectedPatternValues };
            selectedPatternValues[patternKey] = e.value;
            this.setState({ selectedPatternValues });
        }
    }

    fetchCompaniesList = async () => {
        let { data } = await companiesCrud.getCutDownCompaniesList();
        this.companiesListDataSource = data;
        const formInstance = this.formRef.current.instance();
        formInstance.itemOption("companyid", "editorOptions", { dataSource: data });
    }

    fetchSettingPatterns = async () => {
        let { data } = await settingsCrud.getSettingPatterns();
        this.settingDataPatternsDataSource = data;
        const formInstance = this.formRef.current.instance();
        formInstance.option("items[2].items[0].editorOptions", { dataSource: data });
        if (this.props.preselectedKey) {
            let preselectedPattern = data.find(pattern => pattern.Key === this.props.preselectedKey);
            console.log("preselectedPattern", preselectedPattern);
            if (preselectedPattern) {
                formInstance.updateData("settingspatternid", preselectedPattern.SettingsPatternID);
            }
        }
    }


    createSetting = async () => {
        if (this.formRef.current) {
            const formInstance = this.formRef.current.instance();

            if (formInstance.validate().isValid) {

                try {
                    let formData = formInstance.option("formData");
                    // console.log(formData);
                    let settingData =
                    {
                        "companyid": formData.companyid,
                        "contractid": formData.contractid || 0,
                        "pattern": {
                            "SettingsPatternID": formData.settingspatternid,
                            "Key": this.state.selectedPattern.Key,
                            "Value": this.state.selectedPatternValues[this.state.selectedPattern.Key],
                            "Associated": []

                        }
                    }
                    if (this.state.selectedPattern.DataType === "BOOLEAN" && typeof settingData.pattern.Value === "boolean") {
                        settingData.pattern.Value = settingData.pattern.Value ? "TRUE" : "FALSE";
                    }
                    if (this.state.selectedPattern.Associated && this.state.selectedPattern.Associated.length > 0) {
                        for (let associated of this.state.selectedPattern.Associated) {
                            settingData.pattern.Associated.push({
                                "SettingsPatternID": associated.SettingsPatternID,
                                "Key": associated.Key,
                                "Value": associated.DataType === "BOOLEAN" && typeof this.state.selectedPatternValues[associated.Key] === "boolean"
                                    ? this.state.selectedPatternValues[associated.Key] ? "TRUE" : "FALSE"
                                    : this.state.selectedPatternValues[associated.Key]
                            });
                        }
                    }
                    await settingsCrud.saveSetting(settingData)
                    this.props.onDialogResult(RESPONSES.SAVE);
                }
                catch (err) {
                    console.error(err);
                    this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
                }
            }
        }
    }
    render() {
        return (
            <>
                <Popup
                    id='SystemSettingsCreateModalPopup'
                    ref={this.popupRef}
                    visible={this.props.visible}
                    onHiding={this.onClose}
                    dragEnabled={true}
                    hideOnOutsideClick={false}
                    width={600}
                    height='auto'>
                    <ScrollView showScrollbar="always" useNative height={500} >

                        <Form
                            ref={this.formRef}
                            onFieldDataChanged={this.formFieldDataChanged}
                            labelMode='outside'
                            labelLocation='left'
                        >
                            <FormItem
                                label={{ visible: false }}
                                dataField="companyid"
                                editorType="dxSelectBox"

                                editorOptions={{
                                    dataSource: this.companiesListDataSource,
                                    showClearButton: true,
                                    valueExpr: 'companyid',
                                    displayExpr: 'name',
                                    searchEnabled: true,
                                    placeholder: "Select a company",
                                }}
                                isRequired={true}
                            />
                            <FormItem
                                label={{ visible: false }}
                                dataField="contractid"
                                editorType="dxSelectBox"
                                visible={!!this.state.selectedPattern?.ContractAllowed}
                                editorOptions={{
                                    
                                    dataSource: this.contractsListDataSource,
                                    showClearButton: true,
                                    valueExpr: 'contractid',
                                    displayExpr: 'name',
                                    searchEnabled: true,
                                    placeholder: "Select a contract (Leave blank for all contracts)",
                                }}
                            />
                            <GroupItem caption="Parent (Main) Setting" colCount={1}>
                                <FormItem
                                    label={{ visible: false }}
                                    dataField="settingspatternid"
                                    editorType="dxSelectBox"

                                    editorOptions={{
                                        dataSource: this.settingDataPatternsDataSource,
                                        showClearButton: true,
                                        valueExpr: 'SettingsPatternID',
                                        displayExpr: 'Key',
                                        searchEnabled: true,
                                        placeholder: "Select a main key",
                                    }}
                                    isRequired={true}
                                />
                                <FormItem
                                    label={{ visible: false }}
                                    dataField="patterndescription"
                                    editorType="dxTextBox"

                                    editorOptions={{
                                        value: this.state.selectedPattern ? this.state.selectedPattern.Description : '',
                                        readOnly: true,
                                    }}
                                />
                                <FormItem
                                    label={{ text: "Value" }}
                                    dataField={"patternvalue_" + this.state.selectedPattern?.Key}
                                    editorType={this.state.selectedPattern?.DataType === "BOOLEAN" ? "dxSwitch" :
                                        this.state.selectedPattern?.DataType === "INTEGER" ? "dxNumberBox" : "dxTextBox"}

                                    editorOptions={{
                                        readOnly: !this.state.selectedPattern || this.state.selectedPattern?.ReadOnly,
                                        format: '#,##0 ',
                                        value: this.state.selectedPatternValues[this.state.selectedPattern?.Key],
                                    }}
                                />
                            </GroupItem>
                            {
                                (this.state.selectedPattern?.Associated || []).map((associatedPattern) => (
                                    <GroupItem key={associatedPattern.Key} caption="Child (Associated) Setting" colCount={1}>
                                        <FormItem
                                            label={{ visible: false }}
                                            editorType="dxTextBox"

                                            editorOptions={{
                                                value: associatedPattern.Key,
                                                readOnly: true,
                                            }}
                                        />
                                        <FormItem
                                            label={{ visible: false }}
                                            editorType="dxTextBox"

                                            editorOptions={{
                                                value: associatedPattern.Description,
                                                readOnly: true,
                                            }}
                                        />
                                        <FormItem
                                            label={{ text: "Value" }}
                                            dataField={"patternvalue_" + associatedPattern.Key}
                                            editorType={associatedPattern.DataType === "BOOLEAN" ? "dxSwitch" :
                                                associatedPattern.DataType === "INTEGER" ? "dxNumberBox" : "dxTextBox"}

                                            editorOptions={{
                                                readOnly: associatedPattern.ReadOnly,
                                                format: '#,##0 ',
                                                value: this.state.selectedPatternValues[associatedPattern.Key],
                                            }}
                                            isRequired={associatedPattern.DataType !== "BOOLEAN" && associatedPattern.Mandatory}
                                        />
                                    </GroupItem>
                                ))
                            }
                        </Form>
                    </ScrollView >
                    <ToolbarItem location="before"
                        locateInMenu="never"
                        template={`<div style=\"font-size: 20px;\">Add Custom Setting</div>`}
                    />
                    <ToolbarItem
                        widget="dxButton"
                        toolbar="bottom"
                        location="after"
                        options={{ text: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_CANCEL' }), onClick: this.onClose }}>
                    </ToolbarItem>
                    <ToolbarItem
                        widget="dxButton"
                        toolbar="bottom"
                        location="after"
                        options={{
                            text: "Create Setting",
                            icon: 'save',
                            onClick: this.createSetting,
                        }}>
                    </ToolbarItem>

                </Popup >
            </>

        );
    }
}

const mapStateToProps = store => ({
    contract: store.contract.contract,
    contractTemplate: store.contract.template,
});

export default connect(mapStateToProps)(withSnackbar(injectIntl(SystemSettingsCreateModal)));